export default __webpack_public_path__ + "static/media/meat_egg.f8853fed.svg";